export const ComponentTypes = {
    BANNERS: 'Banners',
    STANDARD_RAIL: 'StandardRail',
    SHOWS_RAIL: 'ShowsRail',
    SPOTLIGHT_RAIL: 'SpotlightRail',
    FAQS: 'FAQs',
    FREEMIUM_BANNER: 'FreemiumBanner',
    COMING_UP_RAIL: 'ComingUpRail',
    SUBSCRIPTIONS_RAIL: 'SubscriptionsRail',
    CONTENT_TIERS: 'ContentTiers',
    COMPETITION_CAROUSEL: 'CompetitionCarousel',
    FOOTER: 'Footer',
    VIDEO_PLAYER: 'VideoPlayer',
    BENEFITS: 'Features',
    DEVICEGRAPHIC: 'DeviceGraphic',
    COUNTDOWN: 'Countdown',
    TERMSANDCONDITIONS: 'TermsAndConditions',
    FULLSCREEN_BANNER: 'LandingPagesWebAmazonBanner',
    FEATURES_V2: 'FeaturesV2',
    SUPPORTED_DEVICES: 'SupportedDevices',
    REDEEM_PAGE: 'RedeemPage',
    HEROBANNER_CENTER_ALIGNED: 'HeroBannerCenterAligned',
    COMPETITION_DISPLAY: 'CompetitionDisplay',
    MARKET_PROPOSITION: 'LPMarketProposition',
    DAZN_BET: "BetBanner",
    ARTICLES_RAIL: 'ArticlesRail',
    UMS_POPUP_INTRACTION: 'UMSPopupIntraction'
};
